import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar } from '../Avatar';
import useAuth from '../../Hooks/useAuth.js';
import useUser from '../../Hooks/useUser.js';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { API_URL } from '../../constant';

const ProfileMenu = () => {
  const { signOut } = useAuth();
  const { currentUser: userData } = useUser();

  const { t } = useTranslation();

  if (!userData) {
    return null;
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="justify-content-between align-items-center mx-4 inline-flex w-full items-center rounded-md bg-white py-2 hover:cursor-pointer hover:bg-gray-50">
          <Avatar src={userData?.avatar ? `${API_URL}/${userData?.avatar}` : ''} name={userData?.name || 'A'} size="size-11" className="mr-3" />
          {userData?.firstName && userData?.lastName ? `${userData.firstName} ${userData.lastName}` : userData.name}
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 mr-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
      >
        <div className="py-1">
          <MenuItem data-testid='order-history-menu-item'>
            <Link
              key={'order_history'}
              to={`/order-history`}
              className="block py-2 pl-4 text-2xl text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
            >
              {t('Order History')}
            </Link>
          </MenuItem>
          <MenuItem data-testid='contact-menu-item'>
            <Link
              key={'some'}
              to="/contact"
              className="block py-2 pl-4 text-2xl text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
            >
              {t('Contact')}
            </Link>
          </MenuItem>
          <MenuItem data-testid='faq-menu-item'>
            <Link
              key={'some'}
              to="/faq"
              className="block py-2 pl-4 text-2xl text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
            >
              {t('FAQ')}
            </Link>
          </MenuItem>
        </div>
        <div className="py-1">
          <MenuItem data-testid='logout-menu-item'>
            <Link
              key={'some'}
              onClick={signOut}
              className="block py-2 pl-4 text-2xl text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
            >
              {t('Log Out')}
            </Link>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default ProfileMenu;
